export default __webpack_public_path__ + "static/media/image34.f1f34b82.jpg";